import { useEffect } from 'react';
import { useFabContext } from '../contexts/FabContext';
import { IFabConfig } from '../types/shell';

// Important: config object MUST be wrapped in useMemo for stability of reference.
export const useFab = (config: IFabConfig) => {
  const { setFabConfig, clearFabConfig } = useFabContext();

  useEffect(() => {
    setFabConfig(config);
  }, [config, setFabConfig]);

  useEffect(() => {
    return () => {
      clearFabConfig();
    };
  }, [clearFabConfig]);
};
